import { omit, omitBy, clone, get, setWith, unset } from 'lodash';

export interface IGenericObject extends Object {
  [key: string]: any;
}

export type IPath = string | number | Array<string | number>;

export const setIn = (obj, path, value) => setWith(clone(obj), path, value, clone);

export const deleteIn = (obj: IGenericObject, path: IPath): any => {
  const valueAtPath = get(obj, path);
  const objWithClonedPath = setIn(obj, path, valueAtPath);
  unset(objWithClonedPath, path);
  return objWithClonedPath;
};

export const renameObjectProperties = (obj, keysToRename: IGenericObject) =>
  Object.keys(keysToRename).reduce((resultObj, oldKey) => {
    const clonedObj = setIn(resultObj, keysToRename[oldKey], resultObj[oldKey]);
    return deleteIn(clonedObj, oldKey);
  }, obj);

const isEmptyArray = value => Array.isArray(value) && value.length === 0;
const isEmptyValue = value => value === undefined || value === null || value === '' || isEmptyArray(value);

export const deleteEmptyArrays = obj => omitBy(obj, isEmptyArray);
export const deleteEmptyValues = obj => omitBy(obj, isEmptyValue);

export const hasNotEmptyValue = (obj: IGenericObject, keysToOmit: string[] = []) =>
  Object.values(omit(obj, keysToOmit)).some(value => !isEmptyValue(value));
